import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const SpaPackageAvailabilityWrapper = styled.div`
  position: relative;
  padding-bottom: 40px;

  ${media.md`
    & > div:nth-child(1) {
      padding-top: 0px;
    }
  `}
`;
export const MessageBoxWrapper = styled.div`
  margin: ${({ theme }) => theme.spaces.space5};

  ${media.md`
    margin: 20px 0 0 0;
  `}
`;
